<template>
  <div ref="heroBlock" class="pages-product-hero row-75-220-25">
    <!-- Hero wrap -->
    <div class="pages-product-hero__wrap">
      <!-- Hero Media (desk) -->
      <div class="pages-product-hero__media show-for-large">
        <WidgetVideo
          v-if="props.media?.videoUrl"
          class="is-cover"
          :videoUrl="props.media.videoUrl"
          :controls="false"
          :loop="true"
          :autoplay="true"
          :forcePlay="true"
          :muted="true"
        />
        <WidgetPicture
          v-else-if="props.media?.image?.responsiveImage"
          class="is-cover"
          :image="{ custom: props.media.image?.responsiveImage }"
          :lazyLoad="true"
          :alt="props.media.image?.responsiveImage?.alt"
        />
      </div>

      <!-- Hero Text Block -->
      <div class="pages-product-hero__text__wrap">
        <div
          class="pages-product-hero__text__content"
        >
          <div
            v-if="props.pretitle"
            data-animate="preloader-reveal"
            class="pages-product-hero__pretitle is-text-uppercase"
            v-html="props.pretitle"
          />
          <h1
            v-if="props.title"
            data-animate="preloader-reveal"
            class="title-l-1 pages-product-hero__title is-text-uppercase"
            v-html="props.title"
          />

          <!-- Hero Media (mobile) -->
          <div class="pages-product-hero__media hide-for-large">
            <WidgetVideo
              v-if="props.media?.videoUrl"
              class="is-cover"
              :videoUrl="props.media.videoUrl"
              :controls="false"
              :loop="true"
              :autoplay="true"
              :forcePlay="true"
              :muted="true"
            />
            <WidgetPicture
              v-else-if="props.media?.image?.responsiveImage"
              class="is-cover"
              :image="{ custom: props.media.image?.responsiveImage }"
              :lazyLoad="true"
              :alt="props.media.image?.responsiveImage?.alt"
            />
          </div>

          <div
            v-if="props.description"
            data-animate="preloader-opacity"
            class="pages-product-hero__subtitle text-corpo-l"
            v-html="props.description"
          />

          <div class="pages-product-hero__cta">
            <WidgetArrowLink
              :label="$t('cta.askInfo')"
              :link="
                localePath({
                  name: 'contatti',
                })
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesProductHero',
}
</script>

<script setup>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

const props = defineProps({
  pretitle: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  media: {
    type: Object,
    default: () => ({})
  },
})

const isInView = ref(null)
const heroBlock = ref(null)

const lightTheme = setLightTheme()
const route = useRoute()

const lenis = inject('lenis')

const hasPreview = computed(() => props.hero?.previewVideo)
const hasQuickView = computed(() => props.hero?.overlayFullVideo)

const quickview = useState('quickview', () => null)

const blockOverlay = ref(null)
const blockOverlayVideo = ref(null)

const showableCards = ref(false)

const duration = 0.6
const durationFast = 0.4
const durationSlow = 1
const ease = 'power2.inOut'

watch(
  () => isInView.value,
  (isInView) => {
    if (isInView && props.whiteText) {
      document.body.classList?.add('--light-theme')
      lightTheme.value = true
    } else {
      document.body.classList?.remove('--light-theme')
      lightTheme.value = false
    }
  },
)

onUnmounted(() => {
  ScrollTrigger.refresh()
  isInView.value = true
})

onMounted(() => {
  isInView.value = true
  if (isInView.value && props.whiteText) {
    document.body.classList?.add('--light-theme')
    lightTheme.value = true
  }

  ScrollTrigger.create({
    id: 'scrollHero',
    start: 'top top-=5px',
    end: 'bottom top+=40px',
    trigger: heroBlock.value,
    onEnter: () => {
      //console.log('enter scroll')
      isInView.value = true
      /*if (props.hero.whiteText) {
        document.body.classList?.add('--light-theme')
        lightTheme.value = true
      }*/
    },
    onEnterBack: () => {
      //console.log('enter back scroll')
      isInView.value = true
      /*if (props.hero.whiteText) {
        document.body.classList?.add('--light-theme')
        lightTheme.value = true
      }*/
    },
    onLeave: () => {
      //console.log('leave scroll')
      isInView.value = false
    },
    onLeaveBack: () => {
      //console.log('leave back scroll')
      isInView.value = true
      /*if (props.hero.whiteText) {
        console.log(isInView.value)
        document.body.classList?.add('--light-theme')
        lightTheme.value = true
      }*/
    },
  })

  setTimeout(() => {
    if (isInView.value && props.whiteText) {
      document.body.classList?.add('--light-theme')
      lightTheme.value = true
      //console.log('mounted hero timeout if inview -> light true')
    }
  }, 500)
})

watch(
  () => route.path,
  () => {
    if (
      !route?.name?.includes('contacts') &&
      !route?.name?.includes('lets-talk') &&
      !route?.name?.includes('expertise-slug')
    ) {
      document.body.classList?.remove('--light-theme')
      lightTheme.value = false
    }

    isInView.value = true
    //lenis.value.scrollTo(0)
    //
    ScrollTrigger.getById('scrollHero')?.kill(true)
  },
)

const onQuickView = (event) => {
  event.stopPropagation() // Previene la propagazione del click al link
  event.preventDefault() // Previene l'azione predefinita del bottone
  quickview.value = props.hero?.overlayFullVideo
}
</script>

<style lang="scss">
@import './style.scss';

.v-enter-active,
.v-leave-active {
  transition: opacity $speed-fast ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
